<template>
  <ChartFrame :title="name">
    <ApexChart
      :options="options"
      :series="sheets[0].series.map(s => ({ data: s.data, name: $t(s.name) }))"
      :height="height"
    />
    <slot />
  </ChartFrame>
</template>

<script>
import ChartFrame from '@/components/ChartPartials/ChartFrame';
export default {
  name: 'SimpleStackedChart',
  components: {
    ChartFrame
  },
  props: {
    sheets: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    height: {
      type: [Number, String],
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      options: {
        chart: {
          type: 'bar',
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.sheets[0].axis
        }
      }
    };
  }
};
</script>
